import { useEffect } from "react";

interface ToastProps {
  message: string;
  onClose: () => void;
}

export default function Toast({ message, onClose }: ToastProps) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, 2600);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  return (
    <div className="pointer-events-none fixed bottom-8 left-1/2 z-[70] -translate-x-1/2 px-4">
      <div className="animate-toast-in flex items-center gap-2 rounded-full border border-primary-800 bg-background-800 px-5 py-2.5 text-sm text-foreground-100">
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-information-line text-primary-300" />
        </span>
        <span className="whitespace-nowrap">{message}</span>
      </div>
    </div>
  );
}